import { withI18nPlaceholders } from '@change-corgi/core/react/i18n';

import I18N_PLACEHOLDERS from 'config/i18n/placeholders/decisionMakerProfile/decision-maker-profile.yml';

import { DecisionMakerProfile as DecisionMakerProfileBase } from './entryPoint';

export const DecisionMakerProfile = withI18nPlaceholders(I18N_PLACEHOLDERS, DecisionMakerProfileBase);
